import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/common/img-pagetop.svg'


const _withScopeId = n => (_pushScopeId("data-v-ea21e906"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "p-login" }
const _hoisted_3 = { class: "p-login-inner" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "p-login-heading-1" }, "初回パスワード設定", -1))
const _hoisted_5 = {
  key: 0,
  class: "p-login-text-block --no-mt"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "弊社サービスお申込み時に登録された「メールアドレス」「電話番号」を入力し、ご希望されるパスワードを設定してください。", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["onSubmit"]
const _hoisted_9 = {
  key: 0,
  class: "p-login-form__field"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-login-form__label",
  for: "login-mail"
}, "メールアドレス", -1))
const _hoisted_11 = {
  key: 1,
  class: "p-login-form__field"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-login-form__label",
  for: "login-phone"
}, "電話番号 ※数字のみ(ハイフン抜き)で入力してください", -1))
const _hoisted_13 = { class: "p-login-form__field" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-login-form__label",
  for: "set-password"
}, "希望パスワード（英数字含む8文字以上）", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "p-login-form__toggle js-toggle-password",
  type: "button"
}, null, -1))
const _hoisted_16 = { class: "p-login-form__field" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-login-form__label",
  for: "set-password-repeat"
}, "確認のため再度ご入力ください", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "p-login-form__toggle js-toggle-password",
  type: "button"
}, null, -1))
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div class=\"p-login-text-block\" data-v-ea21e906><p class=\"--is-centered\" data-v-ea21e906><a href=\"https://mynavi-agent.jp/privacy/kiyaku.html\" target=\"_blank\" rel=\"noopener noreferrer\" data-v-ea21e906>利用規約</a><br data-v-ea21e906><a href=\"https://mynavi-agent.jp/privacy/\" target=\"_blank\" rel=\"noopener noreferrer\" data-v-ea21e906>個人情報の取り扱いについて</a></p></div><div class=\"p-login-text-block\" data-v-ea21e906><p data-v-ea21e906>個人情報の取り扱いに同意いただいたうえで、登録してください。</p></div>", 2)
const _hoisted_21 = { class: "p-login-form__field --is-centered" }
const _hoisted_22 = { class: "p-login-form__checkbox" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-login-form__label --pc-txt-14 --is-inline",
  for: "login-agree"
}, "同意する", -1))
const _hoisted_25 = { class: "p-login-form__field" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = {
  key: 1,
  class: "p-login-text-block"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("※メールアドレスが不明な場合は、お手数ですが"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://survey.mynavi.jp/cre/?enq=jyLRMFjBeyo%3d",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "お問い合わせフォーム"),
  /*#__PURE__*/_createTextVNode("よりお問い合わせください。")
], -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { class: "p-recommend-form__modal-card -is-complete" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-7" }, "パスワード登録完了", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-recommend-form__modal-close-area" }, null, -1))
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "l-wrapper" }
const _hoisted_35 = { class: "l-wrapper_main" }
const _hoisted_36 = { class: "p-login" }
const _hoisted_37 = { class: "p-login-inner" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "p-login-heading-1" }, "このURLは有効ではありません。", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-login-text-block" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "--is-centered" }, [
    /*#__PURE__*/_createTextVNode("パスワードを登録済の場合はこちらから"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("ログインしてください。")
  ])
], -1))
const _hoisted_40 = { class: "p-login-text-block" }
const _hoisted_41 = { class: "--is-centered" }
const _hoisted_42 = { class: "l-wrapper_nav" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_45 = [
  _hoisted_44
]

import Loading from '@/components/Loading.vue';
import { RouterLink, useRoute } from 'vue-router';
import { putPasswordSetting, postPasswordCheckKey, getEmailAuthInfoByUniqueKey } from '@/api/accountEndpoint';
import { ref } from 'vue';
import { isValidEmail, isValidMaxLength, isValidRequired, isValidHalfNumber, isValidPassWordAllowed, isValidPassWord } from '@/plugins/validation';
import { errorMessage } from '@/constants/validationErrors';
import { domHelperUtils } from '@/utils/domHelper';

import { onMounted } from 'vue';
import { Email1AuthInfoResponse } from '@/types/emailSerurity';

export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordReset',
  setup(__props) {

const route = useRoute();
const isLoading = ref(false);
const uniqueKey = route.params.uniqueKey as string;
const isModalActive = ref(false);
const isAgreed = ref(false);
const isValdUniqueKey = ref(true);
const isEmail1Auth = ref<boolean>(false);

let isErrorEmailInput = ref(false);
let emailErrorMessage = ref('');
let isErrorTelInput = ref(false);
let telErrorMessage = ref('');
let isErrorPasswordInput = ref(false);
let passwordErrorMessage = ref('');
let isErrorPasswordRepeatInput = ref(false);
let isErrorSetting = ref(false);
let settingErrorMessage = ref('');

function scrollToTop() {
  domHelperUtils.scrollToTop();
}

const pwregisterAction = async () => {
  isErrorEmailInput.value = false;
  isErrorTelInput.value = false;
  isErrorPasswordInput.value = false;
  isErrorPasswordRepeatInput.value = false;
  isErrorSetting.value = false;

  isLoading.value = true;

  // メールアドレスの入力値を取得
  const loginMailInput = document.getElementById('login-mail') as HTMLInputElement;
  const loginMailValue = loginMailInput ? loginMailInput.value : '';

  // 電話番号の入力値を取得
  const loginTelInput = document.getElementById('login-phone') as HTMLInputElement;
  const loginTelValue = loginTelInput ? loginTelInput.value : '';

  // パスワードの入力値を取得
  const setPasswordInput = document.getElementById('set-password') as HTMLInputElement;
  const setPasswordValue = setPasswordInput ? setPasswordInput.value : '';

  // 確認パスワード
  const setPasswordRepeatInput = document.getElementById('set-password-repeat') as HTMLInputElement;
  const setPasswordRepeatValue = setPasswordRepeatInput ? setPasswordRepeatInput.value : '';

  // 入力チェック(メールアドレス)
  // メールアドレスの文字数
  if (!isEmail1Auth.value && loginMailValue !== '') {
    if (!isValidMaxLength(loginMailValue, 255)) {
        isErrorEmailInput.value = true;
        emailErrorMessage.value = errorMessage('MAX_LENGTH', { label: 'メールアドレス',  max: '255' });
    }
    // メールアドレスの形式
    if (!isValidEmail(loginMailValue)) {
      isErrorEmailInput.value = true;
      emailErrorMessage.value = errorMessage('EMAIL', {label: 'メールアドレス'});
    }
  }

  // 入力チェック(電話番号)
  if (!isEmail1Auth.value && loginTelValue !== '') {
    // 電話番号の文字数
    if (!isValidMaxLength(loginTelValue, 14)) {
      isErrorTelInput.value = true;
      telErrorMessage.value = errorMessage('MAX_LENGTH', { label: '電話番号',  max: '14' });
    }
    // 電話番号の形式
    if (!isValidHalfNumber(loginTelValue)) {
      isErrorTelInput.value = true;
      telErrorMessage.value = errorMessage('NUMERIC', { label: '電話番号' });
    }
    // Validation phone contain hyphen (-)
    if(loginTelValue.includes('-')) {
      isErrorTelInput.value = true;
      telErrorMessage.value = errorMessage('REQUIRE_NOT_INCLUDE_HYPHEN');
    }
  }

  // 入力チェック(パスワード)
  if (setPasswordValue !== '') {
    // 英数字含む8文字以上であること
    if (!isValidPassWord(setPasswordValue)) {
      isErrorPasswordInput.value = true;
      passwordErrorMessage.value = errorMessage('PASSWORD_RULE', { label: 'パスワード' });
    }

    if (!isValidMaxLength(setPasswordValue, 50)) {
      isErrorPasswordInput.value = true;
      passwordErrorMessage.value = errorMessage('MAX_LENGTH', { label: 'パスワード', max: '50' });
    }

    // 半角英数字・記号（! @ # $ % ^ & * ( ) _ + - = [ ] { } | '）以外は利用できない
    if (!isValidPassWordAllowed(setPasswordValue)) {
      isErrorPasswordInput.value = true;
      passwordErrorMessage.value = errorMessage('PASSWORD_ALLOWED', { label: 'パスワード' });
    }
  }

   // Validation password and confirmpassword is match 
    if (
      setPasswordValue != '' && 
      isErrorPasswordInput.value == false &&
      isErrorPasswordRepeatInput.value == false &&
      setPasswordValue != setPasswordRepeatValue
    ) {
      isErrorPasswordInput.value = true;
      passwordErrorMessage.value = errorMessage('PASSWORD_REPEAT', { label: 'パスワード' });
      isErrorPasswordRepeatInput.value = true;
    }

  // 必須チェック
  if ((!isEmail1Auth.value && loginMailValue === '') || (!isEmail1Auth.value && loginTelValue === '') || setPasswordValue === '' || setPasswordRepeatValue === '') {
    if (!isEmail1Auth.value && !isValidRequired(loginMailValue)) {
      isErrorEmailInput.value = true;
      emailErrorMessage.value = errorMessage('REQUIRED', { label: 'メールアドレス' });
    }
    if (!isEmail1Auth.value && !isValidRequired(loginTelValue)) {
      isErrorTelInput.value = true;
      telErrorMessage.value = errorMessage('REQUIRED', { label: '電話番号' });
    }
    if (!isValidRequired(setPasswordValue)) {
      isErrorPasswordInput.value = true;
      passwordErrorMessage.value = errorMessage('REQUIRED', { label: 'パスワード' });
    }
  }
  if (isErrorEmailInput.value || isErrorTelInput.value || isErrorPasswordInput.value || isErrorPasswordRepeatInput.value) {
    isLoading.value = false;
    return;
  }

  try {
    await putPasswordSetting({
      uniqueKey: uniqueKey,
      password: setPasswordValue,
      emailAddress: loginMailValue,
      telCellular: loginTelValue
    });
  } catch (error) {
    console.error(error);
    let args = (error as { response: { data: { errorDetail: { globalError: { args: string[] }[] } } } }).response.data.errorDetail.globalError[0]
      .args || [];
    let code = (error as { response: { data: { errorDetail: { globalError: { args: string[] }[] } } } }).response.data.errorDetail.globalError[0]
      .code || [];
    if (code === 'EC001') {
      isErrorSetting.value = true;
      settingErrorMessage.value = args[0];
      isLoading.value = false;
      return;
    }
  } finally {
    isLoading.value = false;
  }
  isModalActive.value = true;
  isLoading.value = false;
};
const init = async () => {
  isLoading.value = true;
  try {
    const resCheckKey = await postPasswordCheckKey(uniqueKey);
    isValdUniqueKey.value = resCheckKey.checkResult;
  } finally {
    isLoading.value = false;
  }
};
init();

function showPassword() {
  const toggleButtons = document.querySelectorAll('.js-toggle-password');
  toggleButtons.forEach((toggleButton) => {
    toggleButton.addEventListener('click', function(e) {
      e.preventDefault();
      const passwordField = toggleButton.parentElement?.querySelector('.js-password-field') as HTMLInputElement;
      if (passwordField) {
        if (passwordField.type === 'password') {
          passwordField.type = 'text';
          toggleButton.classList.add('--is-visible');
        } else {
          passwordField.type = 'password';
          toggleButton.classList.remove('--is-visible');
        }
      }
    });
  });
}

const setEmail1AuthInfo = async () => {
  const res = await getEmailAuthInfoByUniqueKey(uniqueKey) as Email1AuthInfoResponse;
  isEmail1Auth.value = !!res?.detail?.isEmail1Auth;
};

onMounted(() => {
  showPassword();
  setEmail1AuthInfo();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    (isValdUniqueKey.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("main", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              (!isEmail1Auth.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
                : _createCommentVNode("", true),
              _createElementVNode("form", {
                class: "p-login-form",
                onSubmit: _withModifiers(pwregisterAction, ["prevent"])
              }, [
                (!isEmail1Auth.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _withDirectives(_createElementVNode("p", { class: "p-login-form__error" }, _toDisplayString(_unref(emailErrorMessage)), 513), [
                        [_vShow, _unref(isErrorEmailInput)]
                      ]),
                      _hoisted_10,
                      _createElementVNode("input", {
                        class: _normalizeClass(["p-login-form__text", { '--is-error': _unref(isErrorEmailInput) }]),
                        id: "login-mail",
                        name: "login-mail",
                        placeholder: "メールアドレス（半角）",
                        maxlength: "255"
                      }, null, 2)
                    ]))
                  : _createCommentVNode("", true),
                (!isEmail1Auth.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _withDirectives(_createElementVNode("p", { class: "p-login-form__error" }, _toDisplayString(_unref(telErrorMessage)), 513), [
                        [_vShow, _unref(isErrorTelInput)]
                      ]),
                      _hoisted_12,
                      _createElementVNode("input", {
                        class: _normalizeClass(["p-login-form__text", { '--is-error': _unref(isErrorTelInput) }]),
                        id: "login-phone",
                        name: "login-phone",
                        placeholder: "電話番号",
                        maxlength: "14"
                      }, null, 2)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives(_createElementVNode("p", { class: "p-login-form__error" }, _toDisplayString(_unref(passwordErrorMessage)), 513), [
                    [_vShow, _unref(isErrorPasswordInput)]
                  ]),
                  _hoisted_14,
                  _createElementVNode("input", {
                    class: _normalizeClass(["p-login-form__text --is-password js-password-field", { '--is-error': _unref(isErrorPasswordInput) }]),
                    id: "set-password",
                    type: "password",
                    name: "set-password",
                    placeholder: "パスワード（半角英数字）",
                    maxlength: "50"
                  }, null, 2),
                  _hoisted_15
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("input", {
                    class: _normalizeClass(["p-login-form__text --is-password js-password-field", { '--is-error': _unref(isErrorPasswordRepeatInput) }]),
                    id: "set-password-repeat",
                    type: "password",
                    name: "set-password-repeat",
                    placeholder: "パスワード（半角英数字）",
                    maxlength: "50"
                  }, null, 2),
                  _hoisted_18
                ]),
                _withDirectives(_createElementVNode("p", { class: "p-login-form__error" }, _toDisplayString(_unref(settingErrorMessage)), 513), [
                  [_vShow, _unref(isErrorSetting)]
                ]),
                _hoisted_19,
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("span", _hoisted_22, [
                    _withDirectives(_createElementVNode("input", {
                      id: "login-agree",
                      type: "checkbox",
                      name: "login-agree",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isAgreed).value = $event))
                    }, null, 512), [
                      [_vModelCheckbox, isAgreed.value]
                    ]),
                    _hoisted_23
                  ]),
                  _hoisted_24
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("button", {
                    class: "p-login-button",
                    type: "submit",
                    disabled: !isAgreed.value
                  }, "登録する", 8, _hoisted_26)
                ])
              ], 40, _hoisted_8),
              (!isEmail1Auth.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_29))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["p-recommend-form__modal js-modal-container", { 'is-active': isModalActive.value }])
          }, [
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_unref(RouterLink), {
                class: "p-recommend-form__modal-help-close js-modal-close-trigger",
                to: "/login/"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("閉じる")
                ]),
                _: 1
              }),
              _hoisted_31,
              _createVNode(_unref(RouterLink), {
                class: "p-recommend-form__modal-help-close-2",
                to: "/login/"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("ログイン画面へ")
                ]),
                _: 1
              })
            ]),
            _hoisted_32
          ], 2)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("main", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _hoisted_38,
                  _hoisted_39,
                  _createVNode(_unref(RouterLink), {
                    class: "p-login-button",
                    to: "/login/"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("ログイン")
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("p", _hoisted_41, [
                      _createVNode(_unref(RouterLink), { to: "/pwreregister/form" }, {
                        default: _withCtx(() => [
                          _createTextVNode("パスワードを忘れた・ログインできない方へ")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("a", {
                class: "g-pagetop",
                href: "#",
                "aria-label": "ページトップへ戻る",
                onClick: _withModifiers(scrollToTop, ["prevent"])
              }, _hoisted_45, 8, _hoisted_43)
            ])
          ])
        ]))
  ], 64))
}
}

})